'use client'
import clsx from "clsx";
import { NextFontWithVariable } from "next/dist/compiled/@next/font";
// import '../styles/globals.css';
import { ArticleBody } from "./ArticleBody.js";

// Font files can be colocated inside of `pages`

export function isRTL(locale: string) {
    if (
        locale.startsWith('ar') ||
        locale.startsWith('fa') ||
        locale.startsWith('ur') ||
        locale.startsWith('ps') ||
        locale.startsWith('he') ||
        locale.startsWith('ui')
    ) {
        return true;
    }
    return false;

}

import en from '../fonts/font.en.js'
import ar from '../fonts/font.ar.js'
import fa from '../fonts/font.fa.js'
import ur from '../fonts/font.ur.js'
import ps from '../fonts/font.ps.js'
const localFonts = {
    en: en,
    ar: ar,
    fa: fa,
    ur: ur,
    ps: ps,
}

// console.log("LCOA", localFonts)


export const StandardArticle = async ({ body, locale }) => {
    const dir = isRTL(locale) ? 'rtl' : 'ltr';
    let fonts;
    try {
        if (['en', 'ar', 'fa', 'ur', 'ps'].includes(locale)) {
            fonts = localFonts[locale] as NextFontWithVariable[];
        } else {
            fonts = localFonts?.en as NextFontWithVariable[];
        }
    } catch {
        fonts = localFonts?.en as NextFontWithVariable[];
    }
    return (
        <html dir={dir} lang={locale}>
            <head>

                <script src="https://cdn.tailwindcss.com"></script>
                <link href="https://cdn.jsdelivr.net/npm/payload-richtext-tiptap/dist/src/globals.css" rel="stylesheet" />
                <link href="https://cdn.jsdelivr.net/npm/payload-richtext-tiptap/dist/src/article-custom.css" rel="stylesheet" />

            </head>

            <body
                className={clsx(
                    'w-full overflow-x-hidden',
                    // fonts.map(f => f.variable).join(' '),
                    // fonts[0].className,
                )}
            >
                <main
                    id="article-standard-wrapper"
                    className="min-h-fit xl:min-h-[100vh] pt-10 pb-6 md:pb-9 lg:pb-12 xl:pb-20"
                >

                    <div className="flex flex-col gap-6 md:gap-9 xl:gap-12 items-center mx-auto mt-8">
                        {/* Article Content */}
                        <section className="w-full flex justify-center">
                            <div className="w-full max-w-full">
                                <div className="w-full flex flex-row justify-center gap-6 overflow-hidden pt-5">
                                    <ArticleBody
                                        body={body}
                                    />
                                </div>
                            </div>
                        </section>

                    </div>
                </main>
                <script src="https://vjs.zencdn.net/8.16.1/video.min.js"></script>

            </body>
        </html>

    )
}